import React from "react";
import styles from "./WeekDateStrip.module.css";

export interface WeekDateStripProps {
  weekDates: Date[];
  selectedDate: Date;
  /** YYYY-MM-DD keys of days in this week that have at least one scheduled
   *  dose or conditional medicine — drives the "has data" visual state. */
  datesWithData: Set<string>;
  onSelect: (date: Date) => void;
}

const DAY_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

function toDateKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

const WeekDateStrip: React.FC<WeekDateStripProps> = ({
  weekDates,
  selectedDate,
  datesWithData,
  onSelect,
}) => {
  return (
    <div className={styles.weekView}>
      {weekDates.map((date) => {
        const selected = isSameDay(date, selectedDate);
        const hasData = !selected && datesWithData.has(toDateKey(date));
        const stateClass = selected
          ? styles.selected
          : hasData
          ? styles.hasData
          : styles.noData;
        return (
          <button
            type="button"
            key={date.toISOString()}
            className={`${styles.dateCard} ${stateClass}`}
            onClick={() => onSelect(date)}
          >
            <span className={styles.dayLabel}>{DAY_LABELS[date.getDay()]}</span>
            <span className={styles.dayNumber}>{date.getDate()}</span>
          </button>
        );
      })}
    </div>
  );
};

export default WeekDateStrip;
